import { useEffect, useState, useCallback } from 'react';
import { lclClient } from '../api/lclClient';
import toast from 'react-hot-toast';

export function useLclMandates({ ics_status = 'all', exported = 'false', search = '' } = {}) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const refetch = useCallback(async () => {
    setLoading(true);
    try { setData(await lclClient.listMandates({ ics_status, exported, search })); }
    catch (e) { toast.error(`Chargement mandats: ${e.message}`); }
    finally { setLoading(false); }
  }, [ics_status, exported, search]);

  const exportCsv = useCallback(async (scope) => {
    const t = toast.loading(`Génération CSV ${scope === 'new' ? 'nouveau' : 'ancien'} ICS…`);
    try {
      const { fileName, content_base64, batch } = await lclClient.exportMandates(scope);
      const bytes = Uint8Array.from(atob(content_base64), (c) => c.charCodeAt(0));
      const blob = new Blob([bytes], { type: 'text/csv;charset=iso-8859-1' });
      const url = URL.createObjectURL(blob);
      const a = Object.assign(document.createElement('a'), { href: url, download: fileName });
      a.click(); URL.revokeObjectURL(url);
      toast.success(`${batch.item_count} mandat(s) exporté(s)`, { id: t });
      await refetch();
    } catch (e) {
      toast.error(`Erreur: ${e.response?.data?.message || e.message}`, { id: t });
    }
  }, [refetch]);

  useEffect(() => { refetch(); }, [refetch]);
  return { data, loading, refetch, exportCsv };
}
